import { useShallow } from "zustand/react/shallow";

import { useCircleAIShellStore } from "../store/circleAIShellStore";

export const useDockState = () =>
  useCircleAIShellStore(
    useShallow(s => ({
      dockMode: s.dockMode,
      setDockMode: s.setDockMode,
      toggleDockMode: s.toggleDockMode,
      isDockManualOverride: s.isDockManualOverride,
      setDockManualOverride: s.setDockManualOverride,
    })),
  );

export const useLeftSidebarState = () =>
  useCircleAIShellStore(
    useShallow(s => ({
      isLeftSidebarVisible: s.isLeftSidebarVisible,
      setLeftSidebarVisible: s.setLeftSidebarVisible,
      toggleLeftSidebarVisible: s.toggleLeftSidebarVisible,
    })),
  );

export const useBannersState = () =>
  useCircleAIShellStore(
    useShallow(s => ({
      dismissBanner: s.dismissBanner,
      restoreBanner: s.restoreBanner,
      restoreAllBanners: s.restoreAllBanners,
    })),
  );
